import {useEffect, useState} from "react";
import {supabase} from "../api/supabase";

export function useTotalRecipesSold({productId}: {productId: number}) {
  const [total, setTotal] = useState<number>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase
      .schema("airtablepg_production")
      .from("fct_recipe_ingredients_with_units")
      .select("total_recipes_sold")
      .eq("recipe_shopify_id", productId)
      .limit(1)
      .then(({data}) => {
        if (data && data[0]?.total_recipes_sold) {
          setTotal(data[0].total_recipes_sold);
        }
        setLoading(false);
      });
  }, []);

  return {
    loading,
    total,
  };
}
